<span
  [ngSwitch]="!!src"
  [ngStyle]="{ color: color, width: width, height: height }"
  class="app-icon-svg"
>
  <span
    *ngSwitchCase="true"
    [ngStyle]="{
      backgroundImage: 'url(' + src + ')',
      width: width,
      height: height
    }"
    class="app-icon-svg__icon-bg"
  ></span>
  <svg-icon-sprite
    *ngSwitchDefault
    [classes]="'app-icon-svg__svg-node'"
    [src]="'./assets/img/icons/sprite.svg#' + name"
    [viewBox]="viewBox"
    [width]="width"
    [height]="height || width"
    class="app-icon-svg__svg-wrapper"
  />
</span>
